import {
  Button,
  Divider,
  Form,
  Input,
} from 'antd';
import { LinkOutlined } from '@ant-design/icons';
import { useCallback } from 'react';
import {
  REQUIRED_FIELD_RULES,
  REQUIRED_PHONE_NUMBER_RULES,
  REQUIRED_RPPS_NUMBER_RULES,
  REQUIRED_STRUCT_NUMBER_RULES,
} from 'libs/validation';
import { User } from 'stores/user/userTypes';

interface UserFormProps {
  onSave?: (newUser: User) => void;
  user?: User;
  disabled?: boolean,
}

export default function UserForm({
  user = undefined,
  onSave = () => {},
  disabled = false,
}: UserFormProps) {
  const onSubmit = useCallback(
    (values: User) => {
      onSave(values);
    },
    [onSave],
  );

  return (
    <Form
      initialValues={user}
      onFinish={onSubmit}
      layout='vertical'
    >
      <Divider
        orientation='left'
        orientationMargin='0'
        className='!text-sm uppercase'
      >
        Contact
      </Divider>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Form.Item
          label='Prénom'
          name='firstName'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
        <Form.Item
          label='Nom'
          name='lastName'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
      </div>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Form.Item
          label='Adresse email'
          name='email'
        >
          <Input disabled />
        </Form.Item>
        <Form.Item
          label='Téléphone'
          name='phone'
          rules={REQUIRED_PHONE_NUMBER_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
      </div>
      <Divider
        orientation='left'
        orientationMargin='0'
        className='!text-sm uppercase'
      >
        FACTURATION
      </Divider>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Form.Item
          label='Adresse'
          name='address'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
        <Form.Item
          label='Code postal'
          name='zip'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
      </div>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Form.Item
          label='Ville'
          name='city'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
        {user?.rib && (
          <Form.Item
            label='RIB'
            name='rib'
            rules={REQUIRED_FIELD_RULES}
          >
            <a
              href={user?.rib}
              target='_blank'
              rel='noreferrer noopener'
            >
              <LinkOutlined className='mr-2' />
              Voir le RIB
            </a>
          </Form.Item>
        )}
      </div>
      <Divider
        orientation='left'
        orientationMargin='0'
        className='!text-sm uppercase'
      >
        ADMINISTRATIF
      </Divider>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Form.Item
          label='Spécialité'
          name='speciality'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
        <Form.Item
          label='Nº RPPS'
          name='rpps'
          rules={REQUIRED_RPPS_NUMBER_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
      </div>
      <div className='grid grid-cols-1 gap-6 md:grid-cols-2'>
        <Form.Item
          label='Raison sociale'
          name='r_social'
          rules={REQUIRED_FIELD_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
        <Form.Item
          label='Nº de structure (AM, FINESS ou SIRET)'
          name='n_struct'
          rules={REQUIRED_STRUCT_NUMBER_RULES}
        >
          <Input disabled={disabled} />
        </Form.Item>
      </div>
      {!disabled && (
        <div className='flex justify-end'>
          <Form.Item>
            <Button
              htmlType='submit'
              type='primary'
            >
              Valider
            </Button>
          </Form.Item>
        </div>
      )}
    </Form>
  );
}
